import { get } from 'lodash';
import { updateQueryCache } from 'api/urql/helpers/mutation';
import { query } from 'components/pages/postContainer/queries';

export const createPosition = (results, args, cache, info) => {
  // handlers go here
  updateQueryCache({
    fieldName: 'positions',
    query,
    handleCacheUpdate: (data) => {
      const positions = get(data, 'positions', null);
      if (positions === null) {
        return null;
      }

      data.positions.push(results.createPosition.position);
      return data;
    },
  })(results, args, cache, info);
};
